
import SvgIcon from "@mui/material/SvgIcon";

const LogoIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path
        clipRule="evenodd"
        d="m15.99087,0c8.83146,0 15.99087,7.15941 15.99087,15.99087c0,6.42133 -3.78484,11.95867 -9.24522,14.50272l-1.24879,-19.25001l0,-6.24643l-2.99829,4.24757l-4.99715,0l-2.99829,-4.24757l0,6.24643s-1.24929,19.24851 -1.24929,19.24951c-5.46038,-2.54405 -9.24472,-8.08138 -9.24472,-14.50222c0,-8.83146 7.15941,-15.99087 15.99087,-15.99087z"
      />
    </SvgIcon>
  );
};

export default LogoIcon;
